(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('home.advertisersManagement', {
                    requireLogin: true,
                    url: 'admin/advertisersManagement/:id/',
                    templateUrl: 'app/admin/userAndBilling/userAndBillingOverview/advertisersManagement/advertisersManagement.html?app_v=deployDate',
                    data: {
                        authorizedRoles: ['Administrator'],
                        navMarker: ['admin', 'advertisersManagement']
                    },
                    params: {
                        id: null
                    },
                    controller: 'advertisersManagementCtrl'
                })
        }]);
})();